import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import React from 'react';

interface Event {
  event_name: string;
  formatted_date: string;
}

interface ScrollingTextProps {
  events: Event[];
}

const ScrollingText: React.FC<ScrollingTextProps> = ({ events }) => {
  return (
    <Box
      sx={{
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '8px',
        p: 1,
        mb: 2,
      }}
    >
      <motion.div
        animate={{ x: ['100%', '-100%'] }}
        transition={{ repeat: Infinity, duration: 50, ease: 'linear' }}
        style={{ display: 'inline-block' }}
      >
        {events.map((event, index) => (
          <Box key={event.event_name} sx={{ display: 'inline-block', mx: 4 }}>
            <Typography
              variant="h6"
              sx={{
                color: '#cc0000',
                fontFamily: 'Bebas Neue',
                fontStyle: 'italic',
              }}
            >
              {event.event_name}
            </Typography>
            <Typography variant="body2" sx={{ color: 'white' }}>
              {event.formatted_date}
            </Typography>
          </Box>
        ))}
      </motion.div>
    </Box>
  );
};

export default ScrollingText;
